// extracted by mini-css-extract-plugin
export default {"note":"DemoDataNote_note__rq+H8","icon":"DemoDataNote_icon__5d5rM"};